import { Icons, Progress } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { useNotification } from 'hooks/useNotification'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { BidPriceTableCellProps } from './types'
import { AButton } from 'views/components/Analytics'
import { useTranslation } from 'react-i18next'
import { BidStatus } from 'modules/domain/bid/types'

const ActualiseCell: FC<BidPriceTableCellProps> = ({ bid, refetch }) => {
  const notify = useNotification()
  const { t } = useTranslation('bid')
  const [progress, submit] = useAProgress(
    async () => {
      await apiClient.post(endpoints.actualiseBid(bid.id))
      await refetch()
    },
    {
      eventName: 'actualise',
      scope: 'change',
      onSuccess: () => notify(Progress.SUCCESS, { title: t('form.notifyEditSuccess') }),
    },
  )

  return (
    <>
      <AButton
        progress={progress}
        //size="small"
        color="secondary"
        background="none"
        Icon={Icons.IconCheck}
        onClick={submit}
        id={'actualise'}
        disabled={bid.status !== BidStatus.published}
      />
    </>
  )
}

export default ActualiseCell
